<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, Tabs } from '#library/components.schema.build.ts'
	import { Storyblok } from '#library/storyblok.svelte.ts'

	interface Props {
		blok: Blok<Tabs>
	}

	let { blok }: Props = $props()
	let on = $state(0)
</script>

<section class="tabs {blok.theme || 'theme-crocus-on-white'}" {...attrs(blok)}>
	{#if blok.tabs?.length}
		{#if blok.title || blok.subtitle}
			<div class="contain">
				<div class="title">{blok.title}</div>
				<div class="subtitle">{blok.subtitle}</div>
			</div>
		{/if}
		<nav class="nav contain" class:shrink={blok.shrink}>
			{#each blok.tabs as item, i (item._uid)}
				<button
					class="link"
					class:left={blok.leftalign}
					class:shrink={blok.shrink}
					class:on={on === i}
					onclick={() => (on = i)}
				>
					{item.title}
				</button>
			{/each}
		</nav>
		{#each blok.tabs as { blocks, _uid }, i (_uid)}
			{#if on === i && blocks?.length}
				{#each blocks as item (item._uid)}
					<!--
                  TODO: This isn't passing theme correctly, but if apply a fix (below) then it breaks existing layouts.
                  <Storyblok.Block
                  blok={{ ...item, theme: 'theme' in item ? item.theme : blok.theme || 'theme-crocus-on-white' }}
               /> -->
					<Storyblok.Block blok={{ ...item, theme: item.theme || blok.theme || 'theme-crocus-on-white' }} />
				{/each}
			{/if}
		{/each}
	{/if}
</section>

<style lang="css">
	.tabs {
		background-color: var(--c-background);
		color: var(--c-foreground);
		padding-block: var(--padding-top, var(--padding-default)) var(--padding-bottom, var(--padding-default));
	}

	.title {
		font: 600 var(--f-h2);
		letter-spacing: var(--ls-h2);
		margin-block-end: 4rem;
	}

	.nav {
		display: flex;
		gap: 1.5rem;
		margin-block: 0 1.5rem;
		overflow-x: auto;
		scrollbar-width: none;

		@media (--from-mobile) {
			flex-direction: row;
			gap: 0;
			/* gap: max(10.5%, 3rem); */
			/* justify-content: center; */
			margin-block: 0.5rem 4rem;

			&.shrink {
				gap: 3rem;
				justify-content: start;

				.link {
					flex: 0 0 auto;
				}
			}

			&::-webkit-scrollbar {
				display: none;
			}
		}
	}

	.link {
		color: var(--c-midground);
		flex: 1 0 auto;
		font: 600 var(--f-h3);
		letter-spacing: var(--ls-h3);
		text-align: start;
		text-decoration: none;
		transition: font-weight 0.5s ease;
		white-space: nowrap;

		&.shrink {
			font: 600 var(--f-h5);
			letter-spacing: var(--ls-h5);
		}

		@media (--from-mobile) {
			text-align: center;

			&.left {
				text-align: start;
			}
		}

		&:hover,
		&.on {
			color: var(--c-foreground);
			text-decoration: underline;
		}
	}
</style>
